var _path, _path2, _g, _path3, _path4, _g2, _path5, _path6, _path7, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3938,
    height: 1059,
    viewBox: "0 0 3938 1059",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3877.59 1059C3877.59 1059 3894.37 954.045 3894.37 650.482C3346.03 650.482 2200.93 593.585 1948.58 58.0001C1947.02 54.685 1944.5 61.5 1944.5 65C1944.5 184.986 1944 1059 1944 1059H3877.59Z",
    fill: "#FAFAFA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7814 1059C16.7814 1059 -0.00012207 954.045 0 650.482C551.741 650.482 1703.77 601.879 1946.5 57C1946.5 176.986 1946.5 1059 1946.5 1059H16.7814Z",
    fill: "#FAFAFA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_3_108)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.9995 648C1430.21 648 1822.41 314.205 1946 57",
    stroke: "url(#paint0_linear_3_108)",
    strokeWidth: 6,
    strokeLinecap: "round"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8335 655.547C1416.7 655.547 1819.8 326.39 1946.83 72.7589",
    stroke: "url(#paint1_linear_3_108)",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M25.8335 658.595C1416.7 658.595 1819.8 337.818 1946.83 84.1862",
    stroke: "url(#paint2_linear_3_108)",
    strokeWidth: 0.6,
    strokeLinecap: "round"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dd_3_108)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3868.54 647.929C2478.04 647.929 2075.04 314.254 1948.04 57.1419",
    stroke: "url(#paint3_linear_3_108)",
    strokeWidth: 6,
    strokeLinecap: "round"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3868.54 655.548C2477.68 655.548 2074.58 326.39 1947.54 72.7592",
    stroke: "url(#paint4_linear_3_108)",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M3868.54 658.595C2477.68 658.595 2074.58 337.818 1947.54 84.1863",
    stroke: "url(#paint5_linear_3_108)",
    strokeWidth: 0.6,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1947.57 356.345C1947.6 355.999 1948.11 355.999 1948.14 356.345L1957.55 467.896C1957.81 470.982 1958.61 473.997 1959.92 476.803L1992.42 546.476C1992.57 546.791 1992.13 547.043 1991.93 546.757L1958.58 498.286C1953.41 490.764 1942.3 490.764 1937.13 498.286L1903.78 546.757C1903.58 547.043 1903.14 546.791 1903.29 546.476L1935.79 476.803C1937.1 473.997 1937.91 470.982 1938.17 467.896L1947.57 356.345Z",
    fill: "url(#paint6_linear_3_108)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1883.8,
    y: 521.022,
    width: 5.54155,
    height: 1.90469,
    transform: "rotate(135 1883.8 521.022)",
    fill: "url(#paint7_linear_3_108)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    width: 5.54155,
    height: 0.2609,
    rx: 0.13045,
    transform: "matrix(0.707107 0.707107 0.707107 -0.707107 2013.93 521.022)",
    fill: "url(#paint8_linear_3_108)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 3.21801,
    height: 1.90469,
    transform: "matrix(0.707107 -0.707107 -0.707107 -0.707107 1873.26 531.558)",
    fill: "url(#paint9_linear_3_108)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 0.798752,
    height: 1.90469,
    transform: "matrix(0.707107 -0.707107 -0.707107 -0.707107 1870.81 534.012)",
    fill: "url(#paint10_linear_3_108)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 2024.47,
    y: 531.558,
    width: 3.21801,
    height: 0.2609,
    rx: 0.13045,
    transform: "rotate(-135 2024.47 531.558)",
    fill: "url(#paint11_linear_3_108)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 2026.44,
    y: 533.527,
    width: 0.470801,
    height: 0.2609,
    rx: 0.13045,
    transform: "rotate(-135 2026.44 533.527)",
    fill: "url(#paint12_linear_3_108)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2009.75 516.101L1984.01 490.357C1974.65 481.005 1968.57 468.883 1966.67 455.795L1955.38 378.093",
    stroke: "url(#paint13_linear_3_108)",
    strokeWidth: 0.424637,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1886.8 516.101L1912.54 490.357C1921.89 481.005 1927.97 468.883 1929.87 455.795L1941.16 378.093",
    stroke: "url(#paint14_linear_3_108)",
    strokeWidth: 0.424637,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1922.76 435.805L1929.45 398.166",
    stroke: "url(#paint15_linear_3_108)",
    strokeWidth: 0.66525,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M1978.8 465.08L1973.78 434.969",
    stroke: "url(#paint16_linear_3_108)",
    strokeWidth: 0.424637,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1968.77 414.058L1967.09 402.349",
    stroke: "url(#paint17_linear_3_108)",
    strokeWidth: 0.424637,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1936.98 364.71L1937.82 359.691",
    stroke: "url(#paint18_linear_3_108)",
    strokeWidth: 0.66525,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M2023.36 605.666C2030.27 613.066 2033.48 616.18 2038.47 620.906",
    stroke: "url(#paint19_linear_3_108)",
    strokeWidth: 0.66525
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1918.57 591.016C1914.34 600.21 1912.26 604.176 1909.01 610.229",
    stroke: "url(#paint20_linear_3_108)",
    strokeWidth: 0.66525
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M2001.67 486.848C2012.6 499.388 2016.69 503.357 2023.9 509.577",
    stroke: "url(#paint21_linear_3_108)",
    strokeWidth: 0.66525
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1938.09 468.445L1940.17 444.311C1940.2 443.906 1940.77 443.841 1940.9 444.227L1957.76 495.753C1957.9 496.162 1957.35 496.435 1957.1 496.081L1938.16 468.689C1938.11 468.618 1938.08 468.531 1938.09 468.445Z",
    fill: "url(#paint22_linear_3_108)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M2797.73 509C2989.19 555.316 3387.71 601.08 3629.87 598.967",
    stroke: "url(#paint23_linear_3_108)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M2095.39 181.519C2127.55 223.402 2189.67 266.837 2239.87 294.991",
    stroke: "url(#paint24_linear_3_108)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_3_108",
    x: 7.99951,
    y: -0.000701904,
    width: 2007,
    height: 729.001,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 12
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 33
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.858824 0 0 0 0 0.34902 0 0 0 0 0.305882 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3_108"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 12
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.858824 0 0 0 0 0.34902 0 0 0 0 0.305882 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_3_108",
    result: "effect2_dropShadow_3_108"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_3_108",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dd_3_108",
    x: 1879.04,
    y: 0.141235,
    width: 2058.5,
    height: 728.788,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 12
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 33
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.858824 0 0 0 0 0.34902 0 0 0 0 0.305882 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3_108"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 12
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.858824 0 0 0 0 0.34902 0 0 0 0 0.305882 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_3_108",
    result: "effect2_dropShadow_3_108"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_3_108",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3_108",
    x1: 1594.67,
    y1: 25.0863,
    x2: 1586.79,
    y2: -111.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC5A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF4858"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3_108",
    x1: 1585.73,
    y1: 41.2886,
    x2: 1578.28,
    y2: -93.5245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC5A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF4858"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3_108",
    x1: 1585.73,
    y1: 44.3357,
    x2: 1578.28,
    y2: -90.4774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC5A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF4858"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3_108",
    x1: 2309.06,
    y1: 25.2396,
    x2: 2316.71,
    y2: -111.412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC5A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF4858"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3_108",
    x1: 2308.65,
    y1: 41.2888,
    x2: 2316.1,
    y2: -93.5242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC5A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF4858"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3_108",
    x1: 2308.65,
    y1: 44.3358,
    x2: 2316.1,
    y2: -90.4773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC5A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF4858"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3_108",
    x1: 2017.77,
    y1: 625.643,
    x2: 1874.7,
    y2: 418.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC5C4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF4858"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3_108",
    x1: 1886.57,
    y1: 521.022,
    x2: 1886.57,
    y2: 522.927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC5A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF4858"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3_108",
    x1: 2.77077,
    y1: 0,
    x2: 2.77077,
    y2: 0.2609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC5A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF4858"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3_108",
    x1: 1.609,
    y1: 0,
    x2: 1.609,
    y2: 1.90469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC5A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF4858"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_3_108",
    x1: 0.399376,
    y1: 0,
    x2: 0.399376,
    y2: 1.90469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC5A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF4858"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_3_108",
    x1: 2026.08,
    y1: 531.558,
    x2: 2026.08,
    y2: 531.819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC5A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF4858"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_3_108",
    x1: 2026.67,
    y1: 533.527,
    x2: 2026.67,
    y2: 533.788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC5A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF4858"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_3_108",
    x1: 1990.93,
    y1: 378.093,
    x2: 1990.93,
    y2: 516.101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D45151",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727494,
    stopColor: "#D45151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885348,
    stopColor: "#D45151",
    stopOpacity: 0.22
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_3_108",
    x1: 1905.62,
    y1: 378.093,
    x2: 1905.62,
    y2: 516.101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D45151",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D45151"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_3_108",
    x1: 1859.19,
    y1: 312.135,
    x2: 1825.6,
    y2: 746.393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D45151",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D45151"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_3_108",
    x1: 1991.35,
    y1: 410.713,
    x2: 2004.31,
    y2: 545.376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D45151",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D45151"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_3_108",
    x1: 1984.66,
    y1: 375.583,
    x2: 1997.62,
    y2: 510.246,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D45151",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D45151"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_3_108",
    x1: 1929.04,
    y1: 348.221,
    x2: 1924.26,
    y2: 406.074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D45151",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D45151"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_3_108",
    x1: 2023.45,
    y1: 605.625,
    x2: 2034.55,
    y2: 623.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D45151",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48081,
    stopColor: "#D45151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D45151",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_3_108",
    x1: 1918.46,
    y1: 591.006,
    x2: 1913.46,
    y2: 611.205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D45151",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48081,
    stopColor: "#D45151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D45151",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_3_108",
    x1: 2001.46,
    y1: 487.198,
    x2: 2016.45,
    y2: 512.215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D45151",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.337869,
    stopColor: "#D45151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D45151",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_3_108",
    x1: 1946.3,
    y1: 443.271,
    x2: 1948.32,
    y2: 498.191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#343640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343640",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_3_108",
    x1: 2797.73,
    y1: 509,
    x2: 3634.27,
    y2: 562.751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D94F55",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.138726,
    stopColor: "#D94F55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.712096,
    stopColor: "#D94F55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D94F55",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_3_108",
    x1: 2095.39,
    y1: 181.519,
    x2: 2235.76,
    y2: 293.529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D94F55",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.138726,
    stopColor: "#D94F55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.712096,
    stopColor: "#D94F55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D94F55",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg);
export default __webpack_public_path__ + "static/media/bg.f0535fd66b6eb92f8c0e72ec515283a5.svg";
export { ForwardRef as ReactComponent };